import { ArrowLeft } from 'lucide-react'

import { Button } from '@ankor-io/ui-components'

export function BackHeader({ label, onBack }: { label: string; onBack: () => void }) {
  return (
    <div className="flex items-center gap-2 mb-4">
      <Button
        plain
        onClick={onBack}
        className="flex items-center"
      >
        <ArrowLeft data-slot="icon" />
        Back
      </Button>
      <span className="text-gray-300 dark:text-gray-600">/</span>
      <span className="text-sm font-medium text-gray-900 dark:text-white">{label}</span>
    </div>
  )
}
